'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.isFiatCurrency = exports.getFiatCurrency = exports.mapToAccount = exports.getUserBalance = void 0;
var tslib_1 = require("tslib");
var signup_1 = require("../adapter/users/signup");
var account_corex_1 = require("../adapter/wallet/account-corex");
function getUserBalance(userWallets, currency) {
    var wallets = getApplicableWallets(userWallets, currency);
    var result = {
        restricted: numberToFinanceFormat(sumRestricted(wallets)),
        bonusBalance: numberToFinanceFormat(sumBonus(wallets)),
        locked: numberToFinanceFormat(sumLocked(wallets, currency)),
        withdrawable: numberToFinanceFormat(sumWithdrawable(wallets)),
        currency: currency,
    };
    return tslib_1.__assign(tslib_1.__assign({}, result), { balance: numberToFinanceFormat(result.locked +
            result.bonusBalance +
            result.withdrawable +
            result.restricted) });
}
exports.getUserBalance = getUserBalance;
function mapToAccount(event) {
    var _a, _b, _c, _d, _e, _f;
    return {
        type: event.Type,
        currencyCode: event.CurrencyCode,
        walletId: event.WalletId,
        userProfileId: event.UserProfileId,
        jurisdictionCode: event.JurisdictionCode,
        balanceAmount: event.Current.BalanceAmount,
        isLocked: event.Current.IsLocked,
        isActive: event.Current.IsActive,
        aggregates: ((_a = event.Current.Aggregates) === null || _a === void 0 ? void 0 : _a['casino-balance'])
            ? {
                'casino-balance': {
                    amount: (_c = (_b = event.Current.Aggregates) === null || _b === void 0 ? void 0 : _b['casino-balance']) === null || _c === void 0 ? void 0 : _c.Amount,
                    counter: (_e = (_d = event.Current.Aggregates) === null || _d === void 0 ? void 0 : _d['casino-balance']) === null || _e === void 0 ? void 0 : _e.Counter,
                },
            }
            : {},
        restrictions: ((_f = event.Current.Restrictions) === null || _f === void 0 ? void 0 : _f.MonetaryDebit)
            ? {
                monetaryDebit: event.Current.Restrictions.MonetaryDebit.map(function (debit) { return ({
                    amount: debit.Amount,
                    currencyCode: debit.CurrencyCode,
                    expiresOn: debit.ExpiresOn,
                }); }),
            }
            : {},
    };
}
exports.mapToAccount = mapToAccount;
function getFiatCurrency(wallets) {
    var fiatAccount = wallets.find(function (account) {
        return account.type === account_corex_1.WalletType.MAIN &&
            account.isActive &&
            isFiatCurrency(account.currencyCode);
    });
    return fiatAccount.currencyCode;
}
exports.getFiatCurrency = getFiatCurrency;
function isFiatCurrency(currencyCode) {
    return (Object.values(signup_1.Currency).includes(currencyCode) &&
        currencyCode !== signup_1.Currency.GLD &&
        currencyCode !== signup_1.Currency.SWP);
}
exports.isFiatCurrency = isFiatCurrency;
function getApplicableWallets(wallets, currency) {
    return wallets.filter(function (wallet) { return wallet.currencyCode === currency && wallet.isActive; });
}
function sumBonus(wallets) {
    var bonusWallets = filterWallets(wallets, account_corex_1.WalletType.BONUS);
    return sumBalance(bonusWallets);
}
function sumLocked(wallets, currency) {
    var type = currency === signup_1.Currency.SWP ? account_corex_1.WalletType.SWEEPSTAKES : account_corex_1.WalletType.LOCKED;
    var lockedWallets = filterWallets(wallets, type);
    return sumBalance(lockedWallets) + sumRestricted(wallets);
}
function sumWithdrawable(wallets) {
    var mainWallets = filterWallets(wallets, account_corex_1.WalletType.MAIN);
    return Math.max(0, sumBalance(mainWallets) - sumRestricted(wallets));
}
function sumRestricted(wallets) {
    var _a;
    var mainWallets = filterWallets(wallets, account_corex_1.WalletType.MAIN);
    return ((_a = mainWallets.reduce(function (sum, current) {
        var _a, _b, _c;
        var restricted = ((_b = (_a = current === null || current === void 0 ? void 0 : current.restrictions) === null || _a === void 0 ? void 0 : _a.monetaryDebit) !== null && _b !== void 0 ? _b : []).reduce(function (restricted, restriction) {
            var _a;
            return restricted + ((_a = restriction.amount) !== null && _a !== void 0 ? _a : 0);
        }, 0);
        return sum + Math.min((_c = current.balanceAmount) !== null && _c !== void 0 ? _c : 0, restricted);
    }, 0)) !== null && _a !== void 0 ? _a : 0);
}
function numberToFinanceFormat(number) {
    if (number === void 0) { number = 0; }
    if (number > 0 || number < 0) {
        return Math.round(number * 100) / 100;
    }
    return number !== null && number !== void 0 ? number : 0;
}
function filterWallets(wallets, type) {
    return wallets.filter(function (wallet) { return wallet.type === type; });
}
function sumBalance(wallets) {
    return wallets.reduce(function (sum, wallet) { var _a; return sum + ((_a = wallet.balanceAmount) !== null && _a !== void 0 ? _a : 0); }, 0);
}
